































import { Vue, Component } from "vue-property-decorator";
import * as REGISTER_USER_QUERY from 'src/graphql/RegisterUser.graphql';
import { auth } from '../auth/AuthService';
import router from '../router';

@Component({

})
export default class Welcome extends Vue {
  message = "Please authorize me."
  sentRequest = false;
  errorMessage = '';

  async mounted() {
  }

  async sendAccessRequest() {
    this.sentRequest = true;
    this.errorMessage = '';

    const res = await this.$apollo.mutate({
      mutation: REGISTER_USER_QUERY,
      variables: { message: this.message },
      errorPolicy: 'all',
    });

    if (res != null && res.errors != null) {
      if (res.errors.length > 0) {
        this.errorMessage = res.errors[0].message;
      } else {
        this.errorMessage = 'The email could not be sent. Please try again later or email manually.';
      }

      this.sentRequest = false
    }
  }

  reLogin() {
    auth.logout();
    auth.login();
    router.replace('/');
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Welcome.vue